import { obterUnidadesMedidaAsync } from "../../services/unidadeMedidaService";

const atualizarUnidadesMedida = async ({ commit }) => {
    const unidadesMedida = await obterUnidadesMedidaAsync();
    commit('atualizarUnidadesMedida', unidadesMedida);
}

const atualizarUnidadeMedida = ({ commit }, unidadeMedida) => {
    commit('atualizarUnidadeMedida', unidadeMedida);
}

const addUnidadeMedida = ({ commit }, unidadeMedida) => {
    commit('addUnidadeMedida', unidadeMedida);
}

const updateUnidadeMedida = ({ commit }, unidadeMedida) => {
    commit('updateUnidadeMedida', unidadeMedida);
}

export default {
    atualizarUnidadesMedida,
    atualizarUnidadeMedida,
    addUnidadeMedida,
    updateUnidadeMedida
}
